// extracted by mini-css-extract-plugin
export default {"container":"MediaPage_container__Xeugh","sidePanel":"MediaPage_sidePanel__8PZpY"};